export function rotatePoint(x: number, y: number, rot: number, midX: number, midY: number) {
  const sin = Math.sin(rot);
  const cos = Math.cos(rot);
  const difX = x - midX;
  const difY = y - midY;

  return {
    x: midX + (difX * cos - difY * sin),
    y: midY + (difX * sin + difY * cos),
  };
}
